import React from 'react';
import './CalendarSettings.css';

const CalendarSettings = ({ cycleDayMode, onCycleDayModeChange }) => {
  return (
    <div className="calendar-settings">
      <div className="page-header">
        <h1 className="page-title">🔧 日曆設定 (Calendar Settings)</h1>
        <p className="page-description">管理日曆顯示偏好和週期日設定</p>
      </div>

      <div className="settings-container">
        {/* Cycle Day Settings */}
        <div className="settings-section">
          <h2 className="section-title">📅 週期日設定 (Cycle Day Settings)</h2>
          <p className="section-description">
            選擇日曆如何顯示學校週期日信息
          </p>
          
          <div className="setting-option">
            <label className="radio-option">
              <input
                type="radio"
                name="cycleDayMode"
                value="normal"
                checked={cycleDayMode === 'normal'}
                onChange={(e) => onCycleDayModeChange(e.target.value)}
              />
              <span className="radio-label">
                <strong>正常週期日 (Normal Week Days)</strong>
                <span className="option-description">
                  使用標準週一至週五的週期日制度，不顯示週期日徽章
                </span>
              </span>
            </label>
          </div>
          
          <div className="setting-option">
            <label className="radio-option">
              <input
                type="radio"
                name="cycleDayMode"
                value="cycle"
                checked={cycleDayMode === 'cycle'}
                onChange={(e) => onCycleDayModeChange(e.target.value)}
              />
              <span className="radio-label">
                <strong>學校週期日 (School Cycle Days)</strong>
                <span className="option-description">
                  使用學校自定義的週期日制度，顯示週期日徽章 (如 [1], [2], [3] 等)
                </span>
              </span>
            </label>
          </div>
        </div>

        {/* Current Setting Display */}
        <div className="current-setting-display">
          <h3>當前設定 (Current Setting)</h3>
          <div className={`setting-badge ${cycleDayMode === 'normal' ? 'normal-mode' : 'cycle-mode'}`}>
            {cycleDayMode === 'normal' ? '正常週期日' : '學校週期日'}
          </div>
          <p className="setting-explanation">
            {cycleDayMode === 'normal' 
              ? '日曆將使用標準週一至週五的週期日制度，不會顯示週期日徽章。'
              : '日曆將顯示學校自定義的週期日徽章，幫助識別學校週期日。'
            }
          </p>
        </div>

        {/* Additional Settings */}
        <div className="settings-section">
          <h2 className="section-title">⚙️ 其他設定 (Other Settings)</h2>
          <p className="section-description">
            更多日曆顯示選項將在未來版本中添加
          </p>
          
          <div className="coming-soon">
            <span className="coming-soon-badge">即將推出</span>
            <ul className="coming-soon-features">
              <li>日曆主題選擇</li>
              <li>事件顯示密度</li>
              <li>週末高亮顯示</li>
              <li>自定義顏色方案</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CalendarSettings;
